export default __webpack_public_path__ + "33c027945a5684df1cebf0f110adcf9a.png";